import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { UserContext } from "../UserContext";
import EnquiryImportTable from "./EnquiryImportTable";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import {
  FormControl,
  TextField,
  Typography,
  Grid,
  Card,
  CardContent,
  Select,
  MenuItem,
  Box,
  IconButton,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DrawerComponent from "./common/DrawerComponent";

function EnquiryImport() {
  const [file, setFile] = useState(null);
  const [cities, setCities] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [status, setStatus] = useState("");
  const { role, user_id } = useContext(UserContext);
  const [command, setCommand] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  useEffect(() => {
    fetchCountries();
  }, []);

  const [selectedCity, setSelectedCity] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
  const [newCompany, setNewCompany] = useState({
    company_name: "",
    address: "", // Address is here
    country: "",
    state: "",
    district: "", // City removed from state
    industry_type: "",
    business_model: "",
    contact_number: "",
    email_id: "",
    source: "",
    status: "Pending",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setFileName(event.target.files[0].name);
  };

  const columns = [
    { field: "company_name", headerName: "Company Name" },
    { field: "date", headerName: "Date" },
    { field: "address", headerName: "Address" },
    { field: "country", headerName: "Country" },
    { field: "state", headerName: "State" },
    { field: "district", headerName: "District" },
    { field: "industry_type", headerName: "Industry Type" },
    { field: "business_model", headerName: "Business Model" },
    { field: "contact_number", headerName: "Contact Number" },
    { field: "email_id", headerName: "EmailId" },
    { field: "source", headerName: "Source" },
    { field: "created_by_name", headerName: "Created_by" },
    { field: "command", headerName: "Command" },
    { field: "status", headerName: "Status" },
    {
      field: "action",
      headerName: "View",
      renderCell: (params) => (
        <VisibilityIcon
          onClick={() => handleView(params.row)}
          style={{ cursor: "pointer", color: "#555" }}
        />
      ),
    },
  ];

  const fetchCountries = async () => {
    try {
      const res = await axios.get(
        "https://countriesnow.space/api/v0.1/countries/",
      );
      if (res.data && res.data.data) {
        setCountryList(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Failed to load countries");
    }
  };

  const fetchStates = async (countryName) => {
    try {
      const res = await axios.post(
        "https://countriesnow.space/api/v0.1/countries/states",
        { country: countryName },
      );
      if (res.data && !res.data.error && res.data.data.states) {
        setStateList(res.data.data.states);
        setDistrictList([]);
      } else {
        setStateList([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStateList([]);
    }
  };

  const fetchDistricts = async (countryName, stateName) => {
    try {
      const res = await axios.post(
        "https://countriesnow.space/api/v0.1/countries/state/cities",
        { country: countryName, state: stateName },
      );

      if (res.data && !res.data.error && res.data.data) {
        const formattedList = res.data.data.map((city) => ({ name: city }));
        setDistrictList(formattedList);
      } else {
        setDistrictList([]);
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      setDistrictList([]);
    }
  };

  const getCities = async () => {
    try {
      // Changed query param to list=districts
      const res = await axios.get("/api/import-enquiries/?list=districts");
      setCities(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // 2. Fetch Table Data (Filter by District)
  const getTableData = async () => {
    try {
      const params = {
        page: page,
        limit: itemsPerPage,
      };

      // Changed 'address' to 'district' for filtering
      if (selectedCity) params.district = selectedCity;
      if (searchQuery) params.search = searchQuery;

      const res = await axios.get("/api/import-enquiries/", { params });
      setTableData(res.data.data);
      setTotalCount(res.data.total);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCities();
  }, []);

  useEffect(() => {
  
    if (selectedCity || searchQuery) { 
      getTableData();
    }
  }, [page, selectedCity, searchQuery]);

  const importCompanies = async () => {
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("created_by", user_id);
      const res = await axios.post("api/import-enquiries/", formData);
      toast.success("Imported successfully!");
      getCities();
    } catch (error) {
      console.log(error);
      toast.error("Import failed");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    importCompanies();
  };

  const handleView = (company) => {
    setSelectedCompany(company);
    setStatus(company.status);
    setCommand(company.command);
    setOpen(true);
  };

  const handleOpenAddDrawer = () => {
    setNewCompany({
      company_name: "",
      address: "",
      industry_type: "",
      business_model: "",
      contact_number: "",
      email_id: "",
      source: "",
      status: "Pending",
    });
    setIsAddDrawerOpen(true);
  };

  const handleCloseAddDrawer = () => {
    setIsAddDrawerOpen(false);
  };

  const handleCountryChange = (e) => {
    const countryName = e.target.value;
    setNewCompany((prev) => ({
      ...prev,
      country: countryName,
      state: "",
      district: "",
    }));
    if (countryName) {
      fetchStates(countryName);
    } else {
      setStateList([]);
      setDistrictList([]);
    }
  };

  const handleStateChange = (e) => {
    const stateName = e.target.value;
    setNewCompany((prev) => ({
      ...prev,
      state: stateName,
      district: "",
    }));
    if (stateName) {
      fetchDistricts(newCompany.country, stateName);
    } else {
      setDistrictList([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCompany((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isValidPhone = (phone) => {
    const regex = /^\d{10}$/;
    return regex.test(phone);
  };

  const handleAddSubmit = async () => {
    const contact = newCompany.contact_number.trim();
    const email = newCompany.email_id.trim();

    if (email && !isValidEmail(email)) {
      toast.error("Please enter a valid Email ID.");
      return;
    }
    if (!newCompany.country) {
      toast.error("Country is required.");
      return;
    }
    if (!newCompany.state) {
      toast.error("State is required.");
      return;
    }
    if (!newCompany.district) {
      toast.error("District is required.");
      return;
    }

    if (contact && !isValidPhone(contact)) {
      toast.error("Please enter a valid Contact Number.");
      return;
    }

    setIsSubmitting(true);
    try {
      const dataToSubmit = {
        ...newCompany,
        created_by: user_id,
      };

      await axios.post("api/import-enquiries/", dataToSubmit);

      alert("Company added successfully!");
      handleCloseAddDrawer();

      getCities();
      if (selectedCity) {
        getTableData();
      }
    } catch (error) {
      console.error("Error adding company:", error);
      alert("Failed to add company.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleStatusChange = (e) => setStatus(e.target.value);

  const sendUpdateRequest = async (latitude, longitude) => {
    try {
      const formData = new FormData();
      formData.append("status", status);
      formData.append("command", command);
      if (latitude !== null) formData.append("latitude", latitude);
      if (longitude !== null) formData.append("longitude", longitude);

      await axios.patch(
        `/api/import-enquiries/?id=${selectedCompany.id}`,
        formData,
      );
      toast.success("Status updated successfully!");
      setOpen(false);
      getTableData();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(`Failed to update status.`);
    }
  };

  const handleUpdateStatus = () => {
    if (!selectedCompany || !selectedCompany.id) return;
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported.");
      sendUpdateRequest(null, null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) =>
        sendUpdateRequest(position.coords.latitude, position.coords.longitude),
      (error) => {
        console.error(error);
        toast.error("Could not get location.");
        sendUpdateRequest(null, null);
      },
    );
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(1);
  };

  const handleCityClick = (city) => {
    setSelectedCity(city);
    setSearchQuery("");
    setPage(1);
  };

  

  const handleGlobalSearch = (event) => {
    setSearchQuery(event.target.value);
    setSelectedCity(""); 
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const totalPages = Math.ceil(totalCount / itemsPerPage);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <div>
            <FormControl style={{ width: "auto", marginRight: "10px" }}>
              <input
                type="file"
                id="file-input"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <Button
                variant="contained"
                component="label"
                htmlFor="file-input"
                style={{ backgroundColor: "#fb7102", color: "#fff" }}
              >
                {fileName ? `Selected: ${fileName}` : "Select File"}
              </Button>
            </FormControl>
            <Button
              variant="contained"
              type="submit"
              style={{
                backgroundColor: "#fb7102",
                color: "#fff",
                marginRight: "10px",
              }}
            >
              Import
            </Button>
            <Button
              variant="contained"
              onClick={handleOpenAddDrawer}
              style={{ backgroundColor: "#fb7102", color: "#fff" }}
            >
              + Add Company
            </Button>
          </div>
          {selectedCity && (
            <div style={{ width: "20%" }}>
              <TextField
                label="Search"
                value={searchQuery}
                onChange={handleSearch}
              />
            </div>
          )}
        </div>
      </form>

      {!selectedCity && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <TextField
            label="Global Search"
            type="search"
            size="small"
            value={searchQuery} 
            onChange={handleGlobalSearch}
            sx={{ width: "250px" }}
          />
        </Box>
      )}

      {!selectedCity && !searchQuery ? (
        <Box sx={{ mt: 4 }}>
          <Typography
            variant="h5"
            sx={{ mb: 3, fontFamily: "Josefin Sans", fontWeight: "bold" }}
          >
            Select a District {/* Changed from City */}
          </Typography>
          <Grid container spacing={3}>
            {cities.map((item, index) => (
              // Using item.district for key and logic
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={item.district || index}
              >
                <Card
                  sx={{
                    cursor: "pointer",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    border: "1px solid #eee",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 4px 20px rgba(251, 113, 2, 0.3)",
                      borderColor: "#fb7102",
                    },
                  }}
                  onClick={() => handleCityClick(item.district)}
                >
                  <CardContent sx={{ textAlign: "center", py: 4 }}>
                    <Typography
                      variant="h4"
                      sx={{ fontFamily: "Josefin Sans", color: "#333" }}
                    >
                      {item.district}
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      {item.count} Enquiries
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {cities.length === 0 && (
              <Typography
                sx={{
                  width: "100%",
                  textAlign: "center",
                  mt: 5,
                  color: "#888",
                }}
              >
                No districts found.
              </Typography>
            )}
          </Grid>
        </Box>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setSelectedCity("")}
            sx={{
              mb: 2,
              color: "#fb7102",
              borderColor: "#fb7102",
              "&:hover": { borderColor: "#e06502", backgroundColor: "#fff5f2" },
            }}
          >
            Back to Districts {/* Changed from Cities */}
          </Button>

          <Typography
            variant="h6"
            sx={{
              mb: 2,
              display: "inline-block",
              ml: 2,
              fontFamily: "Josefin Sans",
            }}
          >
            Showing results for:{" "}
            <span style={{ color: "#fb7102", fontWeight: "bold" }}>
              {selectedCity || `Search: "${searchQuery}"`}
            </span>
          </Typography>

          <EnquiryImportTable
            columns={columns}
            data={tableData}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            currentPage={page}
            onPageChange={handlePageChange}
            disableSorting={true}
          />
        </Box>
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "70%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            bgcolor: "#F08B51",
            color: "white",
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" style={{ color: "white" }}>
            Update Status
          </Typography>
          <IconButton onClick={() => setOpen(false)} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ p: 3, maxHeight: "60vh", overflow: "auto" }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Company Name:
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {selectedCompany.company_name}
            </Typography>
          </Box>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Current Status:
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {selectedCompany.status}
            </Typography>
          </Box>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              New Status:
            </Typography>
            <FormControl fullWidth variant="outlined">
              <Select value={status} onChange={handleStatusChange}>
                <MenuItem value="No Answer">No Answer</MenuItem>
                <MenuItem value="Call Back">Call Back</MenuItem>
                <MenuItem value="Not Interested">Not Interested</MenuItem>
                <MenuItem value="Interested">Interested</MenuItem>
                <MenuItem value="Send Info">Send Info</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Busy">Busy</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Command/Note:
            </Typography>
            <TextField
              multiline
              rows={4}
              value={command}
              onChange={(e) => setCommand(e.target.value)}
              fullWidth
              variant="outlined"
            />
          </Box>
        </Box>
        <Box
          sx={{
            bgcolor: "grey.50",
            p: 2,
            borderTop: "1px solid",
            borderColor: "divider",
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            sx={{ borderColor: "#F08B51", color: "#F08B51" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateStatus}
            variant="contained"
            sx={{ bgcolor: "#F08B51" }}
          >
            Update
          </Button>
        </Box>
      </Dialog>

      <DrawerComponent
        open={isAddDrawerOpen}
        onClose={handleCloseAddDrawer}
        title="Add New Company"
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflowY: "auto",
            backgroundColor: "#f5f5f0",
            padding: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 3, fontWeight: "bold", color: "#333" }}
          >
            Enter Company Details
          </Typography>

          <Grid container spacing={3}>
            {/* Company Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={
                  <span>
                    Company Name
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="company_name"
                value={newCompany.company_name}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                  "& .MuiInputLabel-asterisk": {
                    display: "none",
                  },
                }}
              />
            </Grid>

            {/* Contact Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Contact Number"
                name="contact_number"
                value={newCompany.contact_number}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                }}
              />
            </Grid>

            {/* COUNTRY AUTOCOMPLETE */}
            <Grid item xs={12} sm={6}>
              <Autocomplete
                fullWidth
                size="small"
                options={countryList}
                getOptionLabel={(option) => option.country || ""}
                value={
                  countryList.find((c) => c.country === newCompany.country) ||
                  null
                }
                onChange={(event, newValue) => {
                  const countryName = newValue ? newValue.country : "";
                  setNewCompany((prev) => ({
                    ...prev,
                    country: countryName,
                    state: "",
                    district: "",
                  }));
                  if (countryName) {
                    fetchStates(countryName);
                  } else {
                    setStateList([]);
                    setDistrictList([]);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Country <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": { borderColor: "#fb7102" },
                        "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                      },
                    }}
                  />
                )}
              />
            </Grid>

            {/* STATE AUTOCOMPLETE */}
            <Grid item xs={12} sm={6}>
              <Autocomplete
                fullWidth
                size="small"
                options={stateList}
                getOptionLabel={(option) => option.name || ""} // Assuming state object has 'name' property
                value={
                  stateList.find((s) => s.name === newCompany.state) || null
                }
                onChange={(event, newValue) => {
                  const stateName = newValue ? newValue.name : "";
                  setNewCompany((prev) => ({
                    ...prev,
                    state: stateName,
                    district: "", // Reset district
                  }));
                  if (stateName) {
                    fetchDistricts(newCompany.country, stateName);
                  } else {
                    setDistrictList([]);
                  }
                }}
                disabled={!newCompany.country}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        State <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": { borderColor: "#fb7102" },
                        "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                      },
                    }}
                  />
                )}
              />
            </Grid>

            {/* DISTRICT AUTOCOMPLETE */}
            <Grid item xs={12} sm={6}>
              <Autocomplete
                fullWidth
                size="small"
                options={districtList}
                getOptionLabel={(option) => option.name || ""} // Assuming district object has 'name' property
                value={
                  districtList.find((d) => d.name === newCompany.district) ||
                  null
                }
                onChange={(event, newValue) => {
                  const districtName = newValue ? newValue.name : "";
                  setNewCompany((prev) => ({
                    ...prev,
                    district: districtName,
                  }));
                }}
                disabled={!newCompany.state}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        District <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": { borderColor: "#fb7102" },
                        "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                      },
                    }}
                  />
                )}
              />
            </Grid>
            {/* ADDRESS TEXT FIELD (Replaced City) */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={
                  <span>
                    Address <span style={{ color: "red" }}>*</span>
                  </span>
                }
                name="address"
                value={newCompany.address || ""}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                }}
              />
            </Grid>

            {/* Industry Type */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Industry Type"
                name="industry_type"
                value={newCompany.industry_type}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                }}
              />
            </Grid>

            {/* Business Model */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Business Model"
                name="business_model"
                value={newCompany.business_model}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                }}
              />
            </Grid>

            {/* Email ID */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email ID"
                name="email_id"
                value={newCompany.email_id}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                }}
              />
            </Grid>

            {/* Source */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Source"
                name="source"
                value={newCompany.source}
                onChange={handleInputChange}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: "#fb7102" },
                    "&.Mui-focused fieldset": { borderColor: "#fb7102" },
                  },
                }}
              />
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <Button
              variant="outlined"
              onClick={handleCloseAddDrawer}
              sx={{
                borderColor: "#fb7102",
                color: "#fb7102",
                "&:hover": { borderColor: "#d15e00", color: "#d15e00" },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddSubmit}
              disabled={isSubmitting}
              sx={{
                backgroundColor: "#fb7102",
                "&:hover": { backgroundColor: "#d15e00" },
              }}
            >
              {isSubmitting ? "Saving..." : "Save Company"}
            </Button>
          </Box>
        </Box>
      </DrawerComponent>
      <ToastContainer />
    </div>
  );
}

export default EnquiryImport;
